import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';

export type TipoModalMensagem = 'sucesso' | 'erro' | 'atencao' | 'confirmacao';

@Component({
  selector: 'app-modal-mensagem',
  standalone: true,
  imports: [CommonModule, MatIconModule],
  templateUrl: './modal-mensagem.component.html',
  styleUrl: './modal-mensagem.component.scss',
})
export class ModalMensagemComponent {
  @Input() tipo: TipoModalMensagem = 'sucesso';
  @Input() titulo = '';
  @Input() mensagem = '';
  @Input() textoConfirmar = 'OK';
  @Input() textoCancelar = 'Cancelar';
  @Input() exibirCancelar = false;
  @Input() corConfirmar?: string;

  @Output() confirmar = new EventEmitter<void>();
  @Output() cancelar = new EventEmitter<void>();

  get icone(): string {
    switch (this.tipo) {
      case 'sucesso':
        return 'check_circle';
      case 'erro':
        return 'cancel';
      case 'confirmacao':
        return 'help';
      default:
        return 'warning';
    }
  }

  onConfirmar(): void {
    this.confirmar.emit();
  }

  onCancelar(): void {
    this.cancelar.emit();
  }
}
